import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../../config/env';

export const locationApi = createApi({
  reducerPath: 'locationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }), // base URL
  endpoints: (builder) => ({
    getStates: builder.query({
      query: () => `location/states`,
    }),
    getDistricts: builder.mutation({
      query: (states = []) => ({
        url: 'location/districts',
        method: 'POST',
        body: { states },
      }),
    }),
    getSubDistricts: builder.mutation({
      query: (districts = []) => ({
        url: 'location/sub-districts',
        method: 'POST',
        body: { districts },
      }),
    }),
    getVillages: builder.mutation({
      query: (sub_districts = []) => ({
        url: 'location/villages',
        method: 'POST',
        body: { sub_districts },
      }),
    }),
  }),
});

export const {
  useGetStatesQuery,
  useGetDistrictsMutation,
  useGetSubDistrictsMutation,
  useGetVillagesMutation,
} = locationApi;
